<template>
  <div>
    <el-button
      class="new-button"
      :class="[type, width, size]"
      :loading="loading"
      @click.prevent="$emit('button-clicked')"
    >
      {{ title }}
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'NewButton',
  props: {
    title: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'large',
    },
    width: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="sass" scoped>
.new-button
  display: flex
  justify-content: center
  align-items: center
  padding: 0
  font-family: 'Mulish', sans-serif
  font-size: 1.6rem
  font-weight: 800
  border: none
  border-radius: 0.8rem

.large
  height: 5.2rem
.small
  height: 4rem
.fullWidth
  width: 100%
.width98
  width: 9.8rem
  height: 3.2rem
  font-size: 1.4rem

.primary
  background: $mainColor
  color: #FFFFFF
  &:hover
    background: #00833C
  &:active
    background: #006421
  &.el-button.is-loading:before
    background-color: transparent
.secondary
  background: #EBF9EB
  color: $mainColor
  &:hover
    background: #00833C
    color: #FFFFFF
  &:active
    background: #006421
    color: #FFFFFF
  .not-allowed
    cursor: default
    &:hover, &:active
      background: #EBF9EB
      color: $mainColor
  &.el-button.is-loading:before
    background-color: transparent
.gray
  background: #EFEFEF
  color: #8A8A8A
</style>
